const dsBridge = require('dsbridge')
export default {
  /**
   * 调用APP中函数并返回数据，异步调用
   * @param name 命名空间
   * @param data 传递参数
   * @param callback 回调
   */
  callMethodAsyn(name, data, callback) {
    dsBridge.call(name, data, data => {
      callback(data)
    })
  },
  /**
   * app调用js方法
   * @param tag 方法名
   * @param callback 接收到的参数
   */
  registerMethod(tag, callback) {
    dsBridge.register(tag, callback)
  },
  /**
   * 调用APP并返回数据，同步调用
   * @param name
   * @param data
   * @returns 参数
   */
  callMethodSyn(name, data) {
    return dsBridge.call(name, data, { msg: 'callSyn' })
  }
}
